<template>
  <div class="text-center">
    <v-layout>
      <v-flex xs12 md6 offset-md-3>
        <v-btn data-cy="backBtn" v-if="!updatingEnabled" style='width:100%;margin-bottom: 10px;' @click="$emit('back')">
          <v-icon>mdi-chevron-up</v-icon>{{$t('Back')}}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-form ref="form" v-model="valid" lazy-validation autocomplete="off" >
      <v-layout>
        <v-flex xs12 md6 offset-md-3>
          <v-switch
            data-cy="driverOwnerOperatorSWITCH"
            :disabled="isFieldReadOnly('driverOwnerOperatorSWITCH')"
            v-if="!isFieldHidden('driverOwnerOperatorSWITCH') && !updatingEnabled"
            class="ml-5"
            v-model="isDriverOwnerOperator"
            @change="onOwnerOperatorSwitch"
            inset hide-details
            :label="$t('User.Fields.driverOwnerOperatorSWITCH')"></v-switch>
          <!--<DriverRates
            v-if="!isFieldHidden('driverRatesJSON') || !isFieldReadOnly('driverRatesJSON')"
            :readonly="isFieldReadOnly('driverRatesJSON')"
            :currentSoloRate="fields.driverCurrentSoloRate"
            :currentTeamRate="fields.driverCurrentTeamRate"
            :driverRatesJSON="fields.driverRatesJSON"
            :userId="userId"
            @changed="(e) => {fields.driverRatesJSON = JSON.stringify(e);}"
            >
          </DriverRates>
          <br/>-->
          <v-menu v-if="!isFieldHidden('dob')"
                  v-model="dobDATEMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                class="mb-1"
                data-cy="dobDATE"
                :disabled="isFieldReadOnly('dob')"
                :loading="isFieldLoading('dob')"
                v-model="dobDATEFormatted"
                @blur="fields.dob = parseDate(dobDATEFormatted)"
                :label="$t('User.Fields.dob')"
                v-on="on" outlined dense hide-details/>
              <!--hint="MM/DD/YYYY" -->
            </template>
            <v-date-picker
              @change="dobDateChange"
              v-model="fields.dob"
              no-title
              @input="dobDATEMenu = false"/>
          </v-menu>
            <!--<v-flex xs12 md4>
              <v-switch
                data-cy="driverIsWorkOnPercentSWITCH"
                :disabled="isFieldReadOnly('driverIsWorkOnPercentSWITCH')"
                v-if="!isFieldHidden('driverIsWorkOnPercentSWITCH')"
                class="ml-10"
                v-model="isDriverWorkOnPercent"
                inset
                :label="$t('User.Fields.driverIsWorkOnPercentSWITCH')"></v-switch>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                data-cy="driverPercentRate"
                class="mb-2"
                :disabled="isFieldReadOnly('driverPercentRate')"
                v-if="fields.driverIsWorkOnPercentSWITCH && !isFieldHidden('driverPercentRate')"
                v-model="fields.driverPercentRate"
                :label="$t('User.Fields.driverPercentRate')"
                suffix="%"
                prepend-icon="fa-percent"
                type="number" step="0.1" @mousewheel.prevent="" outlined hide-details dense>
              </v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                data-cy="driverTeamPercentRate"
                class="mb-2"
                :disabled="isFieldReadOnly('driverTeamPercentRate')"
                v-if="fields.driverIsWorkOnPercentSWITCH && !isFieldHidden('driverTeamPercentRate')"
                v-model="fields.driverTeamPercentRate"
                :label="$t('User.Fields.driverTeamPercentRate')"
                suffix="%"
                prepend-icon="fa-percent"
                type="number" step="0.1" @mousewheel.prevent="" outlined hide-details dense>
              </v-text-field>
            </v-flex>-->
            <v-menu v-if="!isFieldHidden('driverDrivingLicenseValidDATE')"
                    v-model="driverDrivingLicenseValidDATEMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y max-width="290px" min-width="290px" hide-details>
              <template v-slot:activator="{ on }">
                <v-text-field
                  data-cy="driverDrivingLicenseValidDATE"
                  class="mb-1"
                  :disabled="isFieldReadOnly('driverDrivingLicenseValidDATE')"
                  :loading="isFieldLoading('driverDrivingLicenseValidDATE')"
                  v-model="driverDrivingLicenseValidDATEFormatted"
                  @blur="fields.driverDrivingLicenseValidDATE = parseDate(driverDrivingLicenseValidDATEFormatted)"
                  :label="$t('User.Fields.driverDrivingLicenseValidDATE')"
                  v-on="on" outlined dense hide-details></v-text-field>
                <!--hint="MM/DD/YYYY" -->
              </template>
              <v-date-picker
                @change="drivingLicenseDateChange"
                v-model="fields.driverDrivingLicenseValidDATE"
                no-title hide-details
                @input="driverDrivingLicenseValidDATEMenu = false"></v-date-picker>
            </v-menu>
            <v-menu v-if="!isFieldHidden('driverMedicalCardValidDATE')"
                    v-model="driverMedicalCardValidDATEMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y max-width="290px" min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="mb-1"
                  data-cy="driverMedicalCardValidDATE"
                  :disabled="isFieldReadOnly('driverMedicalCardValidDATE')"
                  :loading="isFieldLoading('driverMedicalCardValidDATE')"
                  v-model="driverMedicalCardValidDATEFormatted"
                  @blur="fields.driverMedicalCardValidDATE = parseDate(driverMedicalCardValidDATEFormatted)"
                  :label="$t('User.Fields.driverMedicalCardValidDATE')"
                  v-on="on" outlined dense hide-details></v-text-field>
                <!--hint="MM/DD/YYYY"-->
              </template>
              <v-date-picker
                @change="medicalCardDateChange"
                v-model="fields.driverMedicalCardValidDATE"
                no-title
                @input="driverMedicalCardValidDATEMenu = false"></v-date-picker>
            </v-menu>

            <v-text-field data-cy="driverDrivingLicense"
                          class="mb-1"
                          :disabled="isFieldReadOnly('driverDrivingLicense')"
                          v-if="!isFieldHidden('driverDrivingLicense')"
                          v-model="fields.driverDrivingLicense"
                          :label="$t('User.Fields.driverDrivingLicense')"
                          type="text"
                          outlined dense hide-details/>
            <v-text-field class="mb-1"
                          prefix="$"
                          v-model="fields.desiredSalary"
                          :label="$t('User.Fields.DesiredSalary')"
                          :rules="$root.fieldRequiredRules"
                          type="text"
                          outlined
                          dense
                          hide-details/>

          <!-- UNIVERSAL USER FIELDS -->
            <v-text-field data-cy="phoneNumber"
                          class="mb-1"
                          :disabled="isFieldReadOnly('phoneNumber')"
                          v-if="!isFieldHidden('phoneNumber')"
                          v-model="fields.phoneNumber"
                          :label="$t('User.Fields.phoneNumber')"
                          type="text"
                          outlined dense hide-details/>
            <v-text-field data-cy="SSN"
                          class="mb-1"
                          :disabled="isFieldReadOnly('SSN')"
                          v-if="!isFieldHidden('SSN')"
                          v-model="fields.SSN"
                          :label="$t('User.Fields.SSN')"
                          :append-icon="updatingEnabled ? (isFieldEncrypted('SSN') ? 'mdi-eye-off' : 'mdi-eye') : null"
                          @click:append="decryptField('SSN',$route.params.id)"
                          :type="isFieldEncrypted('SSN') ? 'password' : 'text'"
                          outlined dense hide-details/>
              <v-select v-model="fields.hiringPosition"
                        :label="$t('User.Fields.HiringPosition')"
                        :rules="$root.fieldRequiredRules"
                        :items="['Company Driver', 'OTR', 'Owner Operator']"
                        class="mb-1"
                        outlined
                        dense
                        hide-details/>
              <v-select required
                        v-model="fields.driverTruckTypeAppliedFor"
                        :label="$t('User.Fields.TruckTypeAppliedFor')"
                        :rules="$root.fieldRequiredRules"
                        :items="['26 Box Trucks', '53 Dry Van']"
                        outlined
                        dense
                        hide-details/>
              <v-radio-group v-model="driverAccidentsInLast3Years"
                            @change="driverAccidentsInLast3YearsChange"
                            :label="$t('User.Fields.AccidentsInLast3Years')"
                            class="mb-1" hide-details row>
                <v-radio v-for="n in ['No', 'Yes']"
                        :key="n"
                        :label="`${n}`"
                        :value="n"/>
              </v-radio-group>

              <v-radio-group v-model="fields.driverDrivingExperience"
                             :label="$t('User.Fields.DrivingExperience')"
                             class="mb-2"
                             :rules="$root.fieldRequiredRules"
                             hide-details>
                <v-radio v-for="n in ['Less than 3 months', '6 months', '1 year', 'More than 2 years', 'Other']"
                        :key="n"
                        :label="`${n}`"
                        :value="n"/>
              </v-radio-group>

              <v-textarea data-cy="paymentDetails"
                          class="mb-1"
                          :disabled="isFieldReadOnly('paymentDetails')"
                          v-if="!isFieldHidden('paymentDetails')"
                          v-model="fields.paymentDetails"
                          :label="$t('User.Fields.paymentDetails')"
                          outlined hide-details/>

              <v-textarea v-model="fields.about"
                          label="Additional comments"
                          :rules="$root.fieldRequiredRules"
                          outlined
                          hide-details/>
        </v-flex>
      </v-layout>
    </v-form>
    <UsersFormSaveCancelButtons v-if="isSaveAllowed && updatingEnabled"
                                :loading="isFieldLoading('saveBtn')"
                                @save="saveFields"
                                @cancel="$root.route('/user/page/' + userId)"/>
  </div>
</template>

<script>

import fieldLoadingMixin from '../../mixins/fieldLoadingMixin';
import fieldAccessRightMixin from '../../mixins/fieldAccessRightsMixin';
import userFormsCommonMixin from '../../mixins/userFormsCommonMixin';
import UsersFormSaveCancelButtons from '../../components/UsersFormSaveCancelButtons';

export default {
  components: { UsersFormSaveCancelButtons },
  props: ['updatingEnabled', 'userId', 'ownerOperator', 'isOwnSettings', 'isNew'],
  mixins: [fieldLoadingMixin, fieldAccessRightMixin, userFormsCommonMixin],
  data: () => ({
    valid: true,
    requiredEnabled: true,
    fields: {
      driverCurrentSoloRate: 0,
      driverCurrentTeamRate: 0,
      paymentDetails: '',
      phoneNumber: '',
      SSN: '',
      driverOwnerOperatorSWITCH: 0,
      driverDrivingLicense: '',
      driverDrivingLicenseValidDATE: '',
      driverMedicalCardValidDATE: '',
      driverRatesJSON: '',
      driverTruck: 0,
      driverIsWorkOnPercentSWITCH: 0,
      driverPercentRate: 0,
      driverTeamPercentRate: 0,
      dob: '',
      hiringPosition: '',
      desiredSalary: '',
      about: '',
      driverTruckTypeAppliedFor: '',
      driverDrivingExperience: '',
      driverAccidentsInLast3Years: -1
    },

    driverAccidentsInLast3Years: '',
    dobDATEMenu: false,
    dobDATEFormatted: '',

    driverDrivingLicenseValidDATEMenu: false,
    driverDrivingLicenseValidDATEFormatted: '',

    driverMedicalCardValidDATEMenu: false,
    driverMedicalCardValidDATEFormatted: '',

    trucks: [],
  }),
  computed: {
    isDriverOwnerOperator: {
      set (val) {
        this.fields.driverOwnerOperatorSWITCH = val ? 1 : 0;
      },
      get () {
        return this.fields.driverOwnerOperatorSWITCH === 1;
      }
    },
    isDriverWorkOnPercent: {
      set (val) {
        this.fields.driverIsWorkOnPercentSWITCH = val ? 1 : 0;
      },
      get () {
        return this.fields.driverIsWorkOnPercentSWITCH === 1;
      }
    }
  },
  mounted () {
    if (!this.isNew) {
      this.fetchDataForSettingsModal();
    }
  },
  methods: {
    truckChanged (value) {
      this.fields.driverTruck = value;
    },
    onOwnerOperatorSwitch () {
      this.$emit('ownerOperatorEnable');
    },
    initData () {
      if (this.fields.dob) {
        this.dobDATEFormatted = this.formatDate(this.fields.dob);
      }
      if (this.fields.driverDrivingLicenseValidDATE) {
        this.driverDrivingLicenseValidDATEFormatted = this.formatDate(this.fields.driverDrivingLicenseValidDATE);
      }
      if (this.fields.driverMedicalCardValidDATE) {
        this.driverMedicalCardValidDATEFormatted = this.formatDate(this.fields.driverMedicalCardValidDATE);
      }
      if (parseInt(this.fields.driverAccidentsInLast3Years) === 1) {
        this.driverAccidentsInLast3Years = 'Yes'
      } else {
        this.driverAccidentsInLast3Years = 'No'
      }
    },
    isValid () {
      return this.$refs.form.validate();
    },
    next () {
      if (!this.$refs.form.validate()) {
        this.$root.toast(this.$i18n.t('FormValidationFailed'), { color: 'error' });
        return;
      }
      this.$emit('next');
    },
    driverAccidentsInLast3YearsChange() {
      this.fields.driverAccidentsInLast3Years = this.driverAccidentsInLast3Years === 'Yes' ? 1 : 0;
    },
    dobDateChange() {
      this.dobDATEFormatted = this.formatDate(this.fields.dob);
    },
    drivingLicenseDateChange () {
      this.driverDrivingLicenseValidDATEFormatted = this.formatDate(this.fields.driverDrivingLicenseValidDATE);
    },
    medicalCardDateChange () {
      this.driverMedicalCardValidDATEFormatted = this.formatDate(this.fields.driverMedicalCardValidDATE);
    },
    formatDate (date) {
      if (!date) return null;
      let [year, month, day] = date.substr(0, 10).split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate (date) {
      if (!date) return null;
      const [month, day, year] = date.split('/');
      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    },
    setFields (fields, userRole, rights = null) {
      for (let key in this.fields) {
        this.fields[key] = fields[key] !== null ? fields[key] : '';
      }
      this.initData();
      this.loadImages();
      this.applyRights(this.isOwnSettings ? '' : userRole, this.isOwnSettings ? 'settings' : 'users', { deleteUsersDocuments: 0 });
    }
  }
};
</script>
